<ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
@if (!isOffline) {
  <div>
    <aside id="sidebar-activity">
      @if (gettingUserActivityLastViewed) {
        <ebs-spinner [spinnerMessage]="'initialising sidebar...'" [faColour]="'#666'" [boxColour]="'#666'"
        [boxPadding]="'15px 25px'" [faFont]="'1.8rem'"></ebs-spinner>
      }
      <div class="tab-content">
        <ebs-notification-multiple [notifications]="notifications"></ebs-notification-multiple>
        @if (!gettingUserActivityLastViewed) {
          <div class="tab-pane active p-3 discussion-wrapper" id="activity" role="tabpanel"
            >
            @if (loadingPostAndReplyData) {
              <ebs-spinner [spinnerMessage]="'getting replies...'" [faColour]="'#666'" [boxColour]="'#666'"
              [boxPadding]="'5px 15px'" [faFont]="'1.8rem'"></ebs-spinner>
            }
            @if (!loadingFacultyPostAndReplyData) {
              <div>
                <ebs-group-activity [truncateContentLength]="truncateContentLength" [courseCode]="courseCode"
                  [postAndReplySearchResults]="postAndReplySearchResults" [loadingData]="loadingPostAndReplyData">
                </ebs-group-activity>
                @if (postAndReplySearchResults.length==0) {
                  <span>You have no replies.</span>
                }
                @if (postAndReplySearchResults.length!=0) {
                  <a
                    [routerLink]="['/courses/'  + this.courseCode + '/activities']"
                  class="btn btn-sm btn-outline-secondary btn-block mt-2">View more replies</a>
                }
              </div>
            }
            <hr>
              @if (loadingFacultyPostAndReplyData) {
                <ebs-spinner [spinnerMessage]="'getting faculty replies...'" [faColour]="'#666'" [boxColour]="'#666'"
                [boxPadding]="'5px 15px'" [faFont]="'1.8rem'"></ebs-spinner>
              }
              @if (!loadingFacultyPostAndReplyData) {
                <div>
                  <ebs-faculty-activity [truncateContentLength]="truncateContentLength" [courseCode]="courseCode"
                    [postAndReplySearchResults]="facultyPostAndReplySearchResults"
                  [loadingData]="loadingFacultyPostAndReplyData"></ebs-faculty-activity>
                  @if (facultyPostAndReplySearchResults.length==0) {
                    <span>You have no faculty replies.</span>
                  }
                  @if (facultyPostAndReplySearchResults.length!=0) {
                    <a
                      [routerLink]="['/courses/'+ this.courseCode + '/activities/faculty']"
                    class="btn btn-sm btn-outline-secondary btn-block mt-2">View more faculty replies</a>
                  }
                  <hr>
                  </div>
                }
              </div>
            }
          </div>
        </aside>
      </div>
    }